export default __webpack_public_path__ + "static/media/pic10.7e36c5ba.jpg";